import React, { useState } from 'react';
import { CheckIcon, LockIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'premium'>('premium');
  return <section id="pricing" className="py-16 px-4 bg-slate-950 scroll-mt-10" data-id="element-175">
      <div className="max-w-xl mx-auto" data-id="element-176">
        <div className="text-center mb-10" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-178">
            🛒 ELEGÍ TU PLAN Y EMPEZÁ HOY
          </h2>
          <p className="text-lg text-slate-400 font-medium italic" data-id="element-179">
            Descarga inmediata. Acceso de por vida. El cambio no espera.
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-180">
          {/* Plan 1: Basic — Compact selectable */}
          <div onClick={() => setSelectedPlan('basic')} className={`rounded-xl p-5 cursor-pointer transition-all duration-300 ${selectedPlan === 'basic' ? 'bg-slate-800 border-2 border-slate-500 shadow-lg' : 'bg-slate-900 border border-slate-800 hover:border-slate-700'}`} data-id="element-181">
            <div className="flex items-start gap-3" data-id="element-182">
              <div className="mt-1 flex-shrink-0" data-id="element-183">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'basic' ? 'border-white' : 'border-slate-600'}`} data-id="element-184">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 bg-white rounded-full" data-id="element-185" />}
                </div>
              </div>
              <div className="flex-1" data-id="element-186">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-187">
                  <div data-id="element-188">
                    <h3 className="text-lg font-black text-white" data-id="element-189">
                      📘 PACK BÁSICO
                    </h3>
                    <p className="text-slate-400 text-sm" data-id="element-190">6 guías + 4 bonos</p>
                  </div>
                  <div className="text-right flex-shrink-0" data-id="element-191">
                    <span className="text-slate-500 line-through text-sm block" data-id="element-192">
                      $126.000
                    </span>
                    <span className="text-2xl font-black text-white" data-id="element-193">
                      $19.990
                    </span>
                  </div>
                </div>
                <ul className="space-y-1.5 mt-3" data-id="element-194">
                  {['Tomo 1 — Fundamentos CALMA', 'Tomo 2 — Tablero de Rutinas Mágicas', 'Tomo 3 — Rabietas con Calma', 'Tomo 4 — Diccionario de las Emociones', 'Tomo 5 — Disciplina Sin Gritos', 'Tomo 6 — Diario de la Madre Calmada'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-195">
                      <div className={`w-3 h-3 rounded-full border flex-shrink-0 ${selectedPlan === 'basic' ? 'border-green-500 bg-green-500' : 'border-slate-600'}`} data-id="element-196" />
                      <span className="text-slate-400 text-sm" data-id="element-197">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          {/* Plan 2: Premium — Highlighted selectable */}
          <div onClick={() => setSelectedPlan('premium')} className={`rounded-xl p-5 cursor-pointer transition-all duration-300 relative ${selectedPlan === 'premium' ? 'bg-slate-800 border-2 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-slate-900 border border-slate-700 hover:border-slate-600'}`} data-id="element-198">
            <div className="flex items-start gap-3" data-id="element-199">
              <div className="mt-1 flex-shrink-0" data-id="element-200">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-yellow-400' : 'border-slate-600'}`} data-id="element-201">
                  {selectedPlan === 'premium' && <div className="w-2.5 h-2.5 bg-yellow-400 rounded-full" data-id="element-202" />}
                </div>
              </div>
              <div className="flex-1" data-id="element-203">
                <div className="flex items-start justify-between gap-3 mb-1" data-id="element-204">
                  <div data-id="element-205">
                    <h3 className="text-lg font-black text-white" data-id="element-206">
                      🏆 PACK COMPLETO
                    </h3>
                    <div className="flex flex-wrap gap-2 mt-1.5" data-id="element-207">
                      <span className="bg-yellow-400 text-yellow-900 text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-208">
                        ⭐ Más elegido
                      </span>
                      <span className="bg-red-500 text-white text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-209">
                        Ahorrás $150.010
                      </span>
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0" data-id="element-210">
                    <span className="text-slate-500 line-through text-sm block" data-id="element-211">
                      $180.000
                    </span>
                    <span className="text-3xl font-black text-white" data-id="element-212">
                      $29.990
                    </span>
                  </div>
                </div>
                <p className="text-slate-400 text-sm mt-2 mb-3" data-id="element-213">
                  6 guías + 4 bonos + 2 exclusivos
                </p>
                <div className="space-y-2" data-id="element-214">
                  <div className="flex items-center gap-2 text-yellow-400 font-bold text-sm" data-id="element-215">
                    <span data-id="element-216">+</span>
                    <span className="bg-yellow-400/10 px-2 py-0.5 rounded" data-id="element-217">
                      ⚡ Acelerador 21 Días
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-red-400 font-bold text-sm" data-id="element-218">
                    <span data-id="element-219">+</span>
                    <span className="bg-red-400/10 px-2 py-0.5 rounded" data-id="element-220">
                      🚑 Botiquín de Emergencia Emocional
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Note */}
        <div className="bg-slate-900 border border-slate-800 p-5 rounded-xl mb-8" data-id="element-221">
          <h4 className="text-base font-bold text-yellow-400 mb-2 flex items-center gap-2" data-id="element-222">
            💡 ¿Por qué el 80% de las mamás eligen el Pack Completo?
          </h4>
          <p className="text-slate-400 text-sm leading-relaxed" data-id="element-223">
            Porque no solo te llevás las guías, sino que asegurás la
            implementación real. Son{' '}
            <strong className="text-slate-200" data-id="element-224">
              2 herramientas exclusivas extra
            </strong>{' '}
            por solo $10.000 más: el{' '}
            <strong className="text-slate-200" data-id="element-225">Acelerador 21 Días</strong> para
            crear el hábito, y el{' '}
            <strong className="text-slate-200" data-id="element-226">
              Botiquín de Emergencia Emocional
            </strong>{' '}
            para los momentos críticos.{' '}
            <strong className="text-yellow-400" data-id="element-227">
              No dejes pasar esta oportunidad.
            </strong>
          </p>
        </div>

        {/* CTA Button */}
        <CTAButton text="👉 COMPRAR AHORA" href={selectedPlan === 'basic' ? 'https://checkout.ars.descargatop.com/cart/47474977898754:1' : 'https://checkout.ars.descargatop.com/cart/47474978849026:1'} subtext="Descarga inmediata • Garantía de 7 días" data-id="element-228" />

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-6 text-xs font-bold text-slate-500" data-id="element-229">
          <div className="flex items-center gap-1.5" data-id="element-230">
            <LockIcon className="w-3.5 h-3.5 text-green-500" data-id="element-231" />
            <span data-id="element-232">Pago seguro</span>
          </div>
          <span className="text-slate-700" data-id="element-233">•</span>
          <div className="flex items-center gap-1.5" data-id="element-234">
            <DownloadIcon className="w-3.5 h-3.5 text-green-500" data-id="element-235" />
            <span data-id="element-236">Descarga inmediata</span>
          </div>
          <span className="text-slate-700" data-id="element-237">•</span>
          <div className="flex items-center gap-1.5" data-id="element-238">
            <ShieldCheckIcon className="w-3.5 h-3.5 text-green-500" data-id="element-239" />
            <span data-id="element-240">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}